import ApiService from "@/api/api.service";
import { AxiosPromise } from "axios";

export const apiForgotPassword = (email: string): AxiosPromise => {
  return ApiService.post("/api/auth/forgot-password", { email });
};
